import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import useMakeRequest from "../../utils/ApiHelper";
import { ApiConstants } from "../../constants/ApiConstants";
import FrontLoader from "../layout/FrontLoader";
import { Routes as AppRoutes } from "../../constants/RouteConstants";
import { openPdfUrlInNewBrowserTab } from "../../utils/openQuotationPdf";
import "./QuotationPdfPreview.scss";

/** Legacy route: fetch quote PDF and open it in a new tab, then return to quote details. */
function QuotationPdfPreview() {
  const { id } = useParams();
  const navigate = useNavigate();
  const quotationPdf = useMakeRequest();
  const [opening, setOpening] = useState(false);
  const triggeredRef = useRef(false);
  const openedRef = useRef(false);

  const goBack = () => {
    if (id) navigate(AppRoutes.Viewquote.replace(":id", String(id)));
    else navigate(AppRoutes.MyQuote);
  };

  useEffect(() => {
    triggeredRef.current = false;
    openedRef.current = false;
    setOpening(false);
  }, [id]);

  useEffect(() => {
    if (!id || triggeredRef.current) return;
    triggeredRef.current = true;
    quotationPdf.makeRequest({
      payload: { quotation_id: id },
      url: ApiConstants?.QuotesPdf,
      toastStatus: false,
    });
  }, [id]);

  useEffect(() => {
    if (!quotationPdf?.status || openedRef.current) return;
    const d = quotationPdf?.data?.data as { PDF_URL?: string; quotation_id?: string | number } | undefined;
    if (String(d?.quotation_id) !== String(id)) return;
    const pdfUrl = d?.PDF_URL;
    if (!pdfUrl) {
      toast.error("Could not load PDF.");
      goBack();
      return;
    }

    openedRef.current = true;
    setOpening(true);
    openPdfUrlInNewBrowserTab(pdfUrl);
    setOpening(false);
    goBack();
  }, [quotationPdf?.status, id]);

  return (
    <main className="quotation-pdf-preview">
      {(quotationPdf.loading || opening) && <FrontLoader />}
    </main>
  );
}

export default QuotationPdfPreview;
